import React from 'react';
import Portrait from './Portrait';
import { Server } from '../../server/server';

interface UsersPanelProps {
  users: string[];
  height: string;
  onClick: Function;
}

class UsersPanel extends React.Component<UsersPanelProps, {}> {
  componentDidMount(): void {
    this.load();
  }

  async load() {
    await Server.public.loadProfiles(this.props.users);
    this.forceUpdate();
  }
  
  render() {
    let profiles = [];
    for(let i = 0; i < this.props.users.length; i++) {
      let profile  = Server.public.getProfile(this.props.users[i]);
      if(profile)
        profiles.push(profile);
    }

    profiles.sort((a, b)=>{
      let an = a.name.toLowerCase();
      let bn = b.name.toLowerCase();
      if(an > bn)
        return 1;
      else if(an < bn)
        return -1;
      return 0;
    });

    let divs = [];
    for(let i = 0; i < profiles.length; i++) {
      divs.push(
        <div key={i} className="site-page-row" style={{cursor: 'pointer'}} onClick={()=>this.props.onClick(profiles[i].id)}>
          <Portrait user={profiles[i].id} />
          <div>{profiles[i].name}</div>
        </div>
      )
    }

    return (
      <div className="site-page-scroll-panel" style={{height: this.props.height, padding: '10px'}}>
        <div className="site-page-column">
          {divs}
        </div>
      </div>
    )
  }
}

export default UsersPanel;